import { API_ROUTES } from '@/constants/apiRoutes';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { LineGroupDetailResponse, LineGroupParams } from './lineGroup.types';

export const getLineGroupDetail = (client: AxiosInstance) => async (params?: LineGroupParams) => {
  return (await client.get<LineGroupDetailResponse>(API_ROUTES.GET_LINE_DETAILS, { params })).data;
};

export const lineGroupQueries = {
  all: () => ['lineGroup'],

  detail: (params?: LineGroupParams) =>
    queryFactoryOptions<LineGroupDetailResponse>({
      queryKey: [...lineGroupQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getLineGroupDetail(client)(params),
    }),
};
